import { MdOpenInNew as OpenInNewIcon } from 'react-icons/md';
import { Box, Button, Typography } from '@mui/material';
import { FunctionComponent, MouseEventHandler } from 'react';

const CloudFormationAssumeRoleButton: FunctionComponent<
  React.PropsWithChildren<ICloudFormationAssumeRoleButtonProps>
> = props => {
  const { isDisabled, onOpenCloudFormationStack } = props;

  return (
    <Box gap={1}>
      <Button
        onClick={onOpenCloudFormationStack}
        size='small'
        variant='outlined'
        color='info'
        disabled={isDisabled}
        startIcon={<OpenInNewIcon fontSize='small' />}>
        <Typography>Cloud Formation Assume Role</Typography>
      </Button>
    </Box>
  );
};

export interface ICloudFormationAssumeRoleButtonProps {
  onOpenCloudFormationStack: MouseEventHandler<HTMLButtonElement>;
  isDisabled: boolean;
}

export default CloudFormationAssumeRoleButton;
